import { render } from "./SimpleChart.vue?vue&type=template&id=0d660c51&scoped=true"
import script from "./SimpleChart.vue?vue&type=script&lang=js"
export * from "./SimpleChart.vue?vue&type=script&lang=js"

import "./SimpleChart.vue?vue&type=style&index=0&id=0d660c51&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d660c51"]])

export default __exports__